export default __webpack_public_path__ + "static/media/Full_Branding_WHITE-01.46712cd8.svg";